import styled from "styled-components";
import theme from "themes/simple-theme";

export const Background = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
  left: 0px;
  bottom: 0px;
  top: 0px;
  background-color: ${theme.color.primaryTransparent};
  pointer-events: none;
  z-index: 100;
`;

export const FullScreen = styled.div`
  z-index: 101;
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0px;
  left: 0px;
  color: ${theme.color.white};
  background-color: ${theme.color.primaryTransparent};
`;



// WEBPACK FOOTER //
// ./src/components/Gates/LockScreen/LockScreen.style.tsx